import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseCoreState, baseOffersAndBookingsActions, baseOffersAndBookingsSelectors } from '../../../_store';
import { BaseOffersAndBookingsListPayloadInterface } from '../_interfaces/base-offers-and-bookings-list-payload.interface';

@Injectable({ providedIn: 'root' })
export class BaseOffersAndBookingsGuard {
  constructor(private store: Store<BaseCoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.store.dispatch(
      baseOffersAndBookingsActions.loadOfferOverlapsList({
        payload: route.queryParams as BaseOffersAndBookingsListPayloadInterface,
      })
    );

    return this.store.select(baseOffersAndBookingsSelectors.getOfferOverlapsList).pipe(
      filter((response) => response.ok !== undefined),
      map((response) => !!response.ok)
    );
  }
}
